import React, { useState, useRef, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboardIcon,
  ListChecks,
  Menu,
  ArrowLeft,
  Settings2,
  Settings2Icon,
  User,
  UserCheck2,
} from "lucide-react";

const DashboardLayout = () => {
  const [openMenus, setOpenMenus] = useState({ master: false });

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;
    const level = storedUser?.level;

    fetch(
      `${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`,
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const location = useLocation();
  const pageTitles = {
    "/": "Form Ajuan",
    "/create": "Buat Form Ajuan",
    "/ajuan": "List Ajuan",
    "/m/ajuan": "List Ajuan",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
    "/updateRf/": "Update Ajuan",
    "/ajuan": "Form Ajuan",
  };
  const pageTitle = pageTitles[location.pathname] || "Detail";

  const bottomBarAdmin = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboardIcon },
    { path: "/m/ajuan", label: "Ajuan", icon: ListChecks },
    { path: "/master", label: "Master Data", icon: Settings2 },
    { path: "/account", label: "Pengaturan Akun", icon: UserCheck2 },
  ];

  const bottomBarFinance = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboardIcon },
    { path: "/m/ajuan", label: "Ajuan", icon: ListChecks },
  ];

  const bottomBarEvent = [
    { path: "/m/ajuan", label: "Ajuan", icon: ListChecks },
  ];

  const currentTitle = pageTitles[location.pathname] || "";

  const isActive = (path) => {
    return location.pathname === path;
  };

  // close dropdown when clicked outside
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/login"); // Jika tidak ada user, arahkan ke login
    } else {
      setUser(storedUser);
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSignOut = () => {
    // logika signout di sini
    localStorage.removeItem("user");
    navigate("/login");
  };

  const BASE = process.env.REACT_APP_BASE_URL || "";

  // kalau API balikin object
  const [dataUnread, setDataUnread] = useState(() => {
    const cached = localStorage.getItem("dataUnread");
    return cached ? JSON.parse(cached) : {}; // langsung pakai cache atau object kosong
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(`${BASE}api/dashboard`);
        if (!res.ok) throw new Error("API error");

        const json = await res.json();
        if (mounted) {
          setDataUnread(json);
          localStorage.setItem("dataUnread", JSON.stringify(json));
        }
      } catch (err) {
        console.error("Gagal fetch dashboard:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    const cached = localStorage.getItem("dataUnread");
    if (cached) {
      setDataUnread(JSON.parse(cached));
      setLoading(false); // langsung anggap sudah punya data
    } else {
      setDataUnread({});
      setLoading(true); // masih butuh fetch API
    }

    // 2️⃣ langsung fetch API biar data fresh
    fetchData();

    return () => {
      mounted = false;
    };
  }, [BASE]);

  const rootPages = ["/ajuan", "/"];
  const showBackButton = !rootPages.includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gray-100">
      {/* Sidebar */}
      <aside
        className={`bg-gradient-to-br from-black via-gray-900 to-gray-700 text-white w-64 flex-col absolute md:relative z-50 md:flex ${
          sidebarOpen ? "flex" : "hidden"
        }`}
      >
        <div className="flex items-center gap-2 p-4 border-b border-gray-700">
          <img
            src="/riiv3/images/rii-icon.png"
            alt="RII Logo"
            className="h-8 w-8"
          />
          <span className="text-xl font-bold">Ruang Inspirasi Indonesia</span>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          {["1"].includes(user?.group_id ?? "") && (
            <Link
              to="/dashboard"
              className={`block py-2 px-4 rounded-2xl hover:bg-gray-700 ${
                isActive("/dashboard") ? "bg-gray-700 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
            >
              Dashboard
            </Link>
          )}
          <Link
            to="/"
            className={`block py-2 px-4 rounded-2xl hover:bg-gray-700 ${
              isActive("/") ? "bg-gray-700 font-semibold" : ""
            }`}
            onClick={() => setSidebarOpen(false)}
          >
            <div className="flex justify-between">
              Form Ajuan
              {/* <span className="bg-red-600 text-white text-right text-xs 
                      px-1.5 py-0.5 rounded-full">
                      {dataUnread.summary.counts.byPrintStatus?.unread ?? 0}
                  </span> */}
            </div>
          </Link>
          {["1"].includes(user?.group_id ?? "") && (
            <button
              onClick={() => toggleMenu("master")}
              className="w-full text-left py-2 px-4 rounded-2xl hover:bg-gray-700 flex justify-between items-center"
            >
              Master Data
              <span>{openMenus.master ? "▾" : "▸"}</span>
            </button>
          )}
          {openMenus.master && (
            <ul className="pl-6 mt-1 space-y-1 text-sm text-gray-300">
              <li>
                <Link
                  to="/events"
                  className={`block py-1 px-2 rounded-2xl hover:bg-gray-700 ${
                    isActive("/events") ? "bg-gray-700 font-semibold" : ""
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  Event
                </Link>
              </li>
              <li>
                <Link
                  to="/vendors"
                  className={`block py-1 px-2 rounded-2xl hover:bg-gray-700 ${
                    isActive("/vendors") ? "bg-gray-700 font-semibold" : ""
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  Vendor
                </Link>
              </li>
              <li>
                <Link
                  to="/karyawan"
                  className={`block py-1 px-2 rounded-2xl hover:bg-gray-700 ${
                    isActive("/karyawan") ? "bg-gray-700 font-semibold" : ""
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  Karyawan
                </Link>
              </li>
              <li>
                <Link
                  to="/approval"
                  className={`block py-1 px-2 rounded-2xl hover:bg-gray-700 ${
                    isActive("/approval") ? "bg-gray-700 font-semibold" : ""
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  Approval
                </Link>
              </li>
              <li>
                <Link
                  to="/bank"
                  className={`block py-1 px-2 rounded-2xl hover:bg-gray-700 ${
                    isActive("/bank") ? "bg-gray-700 font-semibold" : ""
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  Akun Bank
                </Link>
              </li>
            </ul>
          )}
          {["1"].includes(user?.group_id ?? "") && (
            <Link
              to="/account"
              className={`block py-2 px-4 rounded-2xl hover:bg-gray-700 ${
                isActive("/account") ? "bg-gray-700 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
            >
              Pengaturan Akun
            </Link>
          )}
        </nav>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Navbar */}
        <>
          {/* ================= MOBILE HEADER ================= */}
          <header className="fixed top-0 left-0 w-full bg-white shadow px-4 py-4 z-[9999] md:hidden">
            <div className="relative flex items-center justify-between">
              {/* LEFT */}
              <div className="flex items-center gap-3 z-10">
                {showBackButton ? (
                  <button
                    onClick={() => navigate(-1)}
                    className="p-2 rounded-full hover:bg-gray-100 transition"
                  >
                    <ArrowLeft className="w-6 h-6 text-gray-700" />
                  </button>
                ) : (
                  <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="p-2 rounded-full hover:bg-gray-100"
                  >
                    <Menu className="w-6 h-6 text-gray-700" />
                  </button>
                )}
              </div>

              {/* CENTER */}
              <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2">
                {showBackButton ? (
                  <h1 className="font-semibold text-lg text-gray-800">
                    {currentTitle}
                  </h1>
                ) : (
                  <img
                    src="/overtime/images/logo-duta-basis-colour.png"
                    alt="Company Logo"
                    className="h-8 w-auto"
                  />
                )}
              </div>

              {/* RIGHT */}
              <div className="relative z-10" ref={dropdownRef}>
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="bg-gray-200 p-2 rounded-full hover:bg-gray-600 transition"
                >
                  <User className="h-5 w-5 text-gray-600 hover:text-white" />
                </button>

                {dropdownOpen && (
                  <div className="absolute right-0 mt-3 w-48 bg-white rounded-xl shadow-lg border">
                    <div className="px-4 py-2 bg-green-100 rounded-t-xl text-sm">
                      {user.level === "finance"
                        ? "Finance"
                        : user.level === "admin"
                          ? "Administrator"
                          : user.level === "event"
                            ? "Event"
                            : "Unknown"}
                    </div>

                    <div className="px-4 py-2 text-sm text-gray-700">
                      {user.email}
                    </div>

                    <button
                      onClick={handleSignOut}
                      className="w-full text-left px-4 py-3 text-red-600 hover:bg-gray-50 rounded-b-xl"
                    >
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </header>

          {/* ================= DESKTOP/TABLET HEADER ================= */}
          <header className="hidden md:flex bg-white shadow px-4 py-4 md:px-6 justify-between items-center relative z-[9999]">
            <div className="flex items-center gap-4">
              <h1 className="text-lg font-semibold text-gray-800">
                {currentTitle}
              </h1>
            </div>

            <div className="relative flex items-center gap-4" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="focus:outline-none bg-gray-200 p-1 rounded-2xl hover:bg-gray-600"
              >
                <User className="h-6 w-6 text-gray-600 hover:text-white" />
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 top-full mt-2 w-48 bg-white border rounded-2xl shadow-md z-50">
                  <div className="px-4 py-2 text-sm text-gray-700 rounded-xl bg-green-200">
                    {user.level === "finance"
                      ? "Finance"
                      : user.level === "admin"
                        ? "Administrator"
                        : user.level === "event"
                          ? "Event"
                          : "Unknown"}
                  </div>

                  <div className="px-4 py-2 text-sm text-gray-700">
                    {user.email}
                  </div>

                  <button
                    onClick={handleSignOut}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 hover:rounded-2xl text-red-600"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </header>
        </>

        {/* Page Content */}
        <main className="px-4 flex-1 pt-24 md:pt-4">
          <Outlet />
        </main>
        <div className="fixed bottom-0 left-0 w-full z-[9999] bg-white border-t shadow-lg md:hidden">
          <div className="flex justify-around items-center h-16">
            {(user?.group_id === "1"
              ? bottomBarAdmin
              : user?.group_id === "2"
                ? bottomBarFinance
                : user?.group_id === "3"
                  ? bottomBarEvent
                  : []
            ).map((menu) => {
              const Icon = menu.icon;
              const active = isActive(menu.path);

              return (
                <button
                  key={menu.path}
                  onClick={() => navigate(menu.path)}
                  className={`flex flex-col items-center justify-center text-xs transition ${
                    active ? "scale-105" : "scale-100"
                  }`}
                >
                  <Icon
                    size={22}
                    className={`mb-1 ${
                      active ? "text-blue-500" : "text-gray-400"
                    }`}
                  />
                  <span
                    className={`${
                      active ? "text-blue-500 font-semibold" : "text-gray-400"
                    }`}
                  >
                    {menu.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
        <footer
          className={`fixed p-6 bottom-0 left-0 w-full bg-white text-black text-sm h-10 flex items-center justify-center z-50 relative`}
          aria-label="footer"
        >
          <div className="max-w-7xl w-full text-center truncate">
            © 2026 Mxm Finance 3. All rights reserved.
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DashboardLayout;
